import "../Css/Skills.css";
import React from "react";

const skills = [
  "Product Engineering",
  "AI Engineering",
  "Test Automation",
  "Product Ownership",
  "Project Management",
  "Quality Assurance",
  "Team Working",
  "Public Speaking",
  "Agentic AI Development",
  "LLM Engineering",
  "LangGraph",
  "LangChain",
  "Retrieval-Augmented Generation (RAG)",
  "Software Engineering",
  "Full-Stack Development",
  "Software Testing",
  "Python",
  "TypeScript",
  "Java",
  "React.js",
  "Node.js",
  "Selenium",
  "Playwright",
  "Maestro",
  "Docker",
  "Git",
  "Linux",
  "Databases",
  "C",
];

const Skills = () => {

  return (

    <section className="mb-3" id="skills">

      {/* <h2 className="section-title">Skills</h2> */}

      <h2 className="section-title">
        <i className="fas fa-screwdriver-wrench"></i> <span style={{ marginLeft: "10px" }}>Skills</span>
      </h2>

      <div className="skills-section-content">

        {
          skills.map((skill, index) => (

            <span key={index} className="skill-badge">
              {skill}
            </span>

          ))
        }

      </div>

    </section>

  );

};

export default Skills;